import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Shared auth input (§9.1). Adds a password visibility toggle (≥44px, aria) and
// correct `autocomplete` semantics so browsers/password managers behave. Used by
// Login and Signup so both stay consistent.
export default function AuthField({
  label,
  type = "text",
  value,
  onChange,
  testid,
  required = false,
  autoComplete,
  name,
  placeholder,
}) {
  const [reveal, setReveal] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword ? (reveal ? "text" : "password") : type;

  return (
    <label className="block">
      <span className="block text-[11px] tracking-[0.22em] uppercase text-brand-ink2 font-ui mb-2">
        {label}
      </span>
      <div className="relative">
        <input
          data-testid={testid}
          type={inputType}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          autoComplete={autoComplete}
          placeholder={placeholder}
          className={`w-full px-4 py-3 rounded-xl border border-brand-line bg-brand-elevated text-white focus:border-brand-rose focus:outline-none transition-colors text-[16px] placeholder:text-brand-ink3 ${
            isPassword ? "pr-12" : ""
          }`}
        />
        {isPassword && (
          <button
            type="button"
            data-testid={`${testid}-toggle`}
            onClick={() => setReveal((v) => !v)}
            aria-label={reveal ? "Ocultar senha" : "Mostrar senha"}
            aria-pressed={reveal}
            className="absolute right-1.5 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center rounded-lg text-brand-ink2 hover:text-brand-rose transition-colors"
          >
            {reveal ? <EyeOff className="w-[18px] h-[18px]" /> : <Eye className="w-[18px] h-[18px]" />}
          </button>
        )}
      </div>
    </label>
  );
}
